// extracted by mini-css-extract-plugin
export default {"root":"QxSaOor7aiZpOMrbT7rw","main":"ETIftU2eVS4AwvCEs_Jr","heading":"dtdrH2m_RAahrvS4x15g","content":"go7LnIgvs4h7hDq4VqPg"};